/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dailog_Redeem_Confirmation_TitleInputs */

const en_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeem This Item?`)
};

const ar_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل تريد استبدال هذا العنصر؟`)
};

const de_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Gegenstand einlösen?`)
};

const es_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Canjear este artículo?`)
};

const fr_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échanger cet article ?`)
};

const it_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscattare questo oggetto?`)
};

const ja_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアイテムを交換しますか？`)
};

const ko_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 아이템을 교환하시겠습니까?`)
};

const pt_br_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgatar este item?`)
};

const ru_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обменять этот предмет?`)
};

const th_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แลกรับไอเทมนี้หรือไม่?`)
};

const tr_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ögeyi al?`)
};

const zh_cn_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定要兑换此物品吗？`)
};

const zh_tw_dailog_redeem_confirmation_title = /** @type {(inputs: Dailog_Redeem_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確定要兌換此品項嗎？`)
};

/**
* | output |
* | --- |
* | "Redeem This Item?" |
*
* @param {Dailog_Redeem_Confirmation_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dailog_redeem_confirmation_title = /** @type {((inputs?: Dailog_Redeem_Confirmation_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dailog_Redeem_Confirmation_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dailog_redeem_confirmation_title(inputs)
	if (locale === "ar") return ar_dailog_redeem_confirmation_title(inputs)
	if (locale === "de") return de_dailog_redeem_confirmation_title(inputs)
	if (locale === "es") return es_dailog_redeem_confirmation_title(inputs)
	if (locale === "fr") return fr_dailog_redeem_confirmation_title(inputs)
	if (locale === "it") return it_dailog_redeem_confirmation_title(inputs)
	if (locale === "ja") return ja_dailog_redeem_confirmation_title(inputs)
	if (locale === "ko") return ko_dailog_redeem_confirmation_title(inputs)
	if (locale === "pt_br") return pt_br_dailog_redeem_confirmation_title(inputs)
	if (locale === "ru") return ru_dailog_redeem_confirmation_title(inputs)
	if (locale === "th") return th_dailog_redeem_confirmation_title(inputs)
	if (locale === "tr") return tr_dailog_redeem_confirmation_title(inputs)
	if (locale === "zh_cn") return zh_cn_dailog_redeem_confirmation_title(inputs)
	return zh_tw_dailog_redeem_confirmation_title(inputs)
});